module.exports = __webpack_public_path__ + "assets/img/2-320x320.b7b54c8f.webp";